import React from "react";
import TimelineNewPost from "./TimelineNewPost";

export default ({ type, setType }) => {
  return (
    <div className="rootContent">
      <div className="actionContent">
        <TimelineNewPost type={type} setType={setType} />
      </div>
    </div>
  );
};
